import { PublicVariables } from "../../../../../constants/PublicVariables";
import { LogFirebase } from "../../../../../services/firestore";
import zoomService from "../../../../../services/zoomService";
import { dualStreamEnabled } from "../../../../../shared/utility";
import { handleVideoSubscribedForMultiStream, handleVideoSubscribedForSingleStream } from "../../../Room/roomFunction";

export const handleVideoTrackSubscribed = (track, remoteTrackPrublication, participant) => {
    if (PublicVariables.isMobile) {
        zoomService.disablePinchZoom();
        setTimeout(function () {
            zoomService.enablePinchZoom(); // enable pinch zoom
        }, 1000);
    }

    LogFirebase("TwilioEvents", "video_track_received", { identity: participant.identity });
    if (dualStreamEnabled()) {
        console.log("dual stream is On");
        handleVideoSubscribedForMultiStream(track, remoteTrackPrublication, participant);
    } else {
        setTimeout(() => {
            handleVideoSubscribedForSingleStream(track, remoteTrackPrublication, participant);
        }, 100);
    }
};
